import { type ButtonSize } from "antd/lib/button";

import { type GridSize } from "commonComponents/utilities/Grid/Grid.types";

export function getButtonSizeFromGridSize(size: GridSize | undefined): ButtonSize {
    return size ?? "middle";
}
